import graphql__741b984d5d8940cf0b18 from "./__generated__/AnswerPreviewSortableList_answer.graphql.js";import { graphql, useFragment } from "react-relay";

const AnswerPreviewSortableList = props => {
  const { formattedValues } = useFragment(AnswerPreviewSortableList_answer, props.answer);

  return (
    <ol className="form-answer-check-boxes-values">
      {formattedValues.map((value, index) => {
        return <li key={index}>{value}</li>;
      })}
    </ol>
  );
};

const AnswerPreviewSortableList_answer = graphql__741b984d5d8940cf0b18;

export default AnswerPreviewSortableList;
